"use client";

import { useState, Suspense } from "react";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { toast } from "sonner";
import { Lock, User } from "lucide-react";
import { googleSignIn } from "./actions";

void [User];

function 登入表單() {
  const searchParams = useSearchParams();
  const [帳號, 設定帳號] = useState("");
  const [密碼, 設定密碼] = useState("");
  const [登入中, 設定登入中] = useState(false);

  const callbackUrl = searchParams.get("callbackUrl") ?? "/";

  async function 帳密登入() {
    if (!帳號.trim() || !密碼.trim()) { toast.error("請輸入帳號與密碼"); return; }
    設定登入中(true);
    const res = await signIn("credentials", { username: 帳號.trim(), password: 密碼, redirect: false });
    設定登入中(false);
    if (res?.ok) { window.location.href = callbackUrl; }
    else { toast.error("帳號或密碼錯誤"); }
  }

  void [帳號, 設定帳號, 密碼, 設定密碼, 帳密登入, 登入中];

  return (
    /* Canvas (#F8F8F8) background with spectrum ambient glow */
    <div className="min-h-screen flex items-center justify-center bg-[#f8f8f8] px-4 relative overflow-hidden">
      {/* Spectrum ambient glow */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] opacity-[0.18] blur-[80px]"
          style={{ background: "radial-gradient(ellipse, #fa3d1d 0%, #c679c4 50%, transparent 80%)" }}
        />
        <div
          className="absolute bottom-0 right-0 w-[400px] h-[300px] opacity-[0.12] blur-[100px]"
          style={{ background: "radial-gradient(ellipse, #0358f7 0%, #e1e1fe 60%, transparent 85%)" }}
        />
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[200px] opacity-[0.08] blur-[80px]"
          style={{ background: "radial-gradient(ellipse, #ffb005 0%, transparent 70%)" }}
        />
      </div>

      <div className="relative w-full max-w-sm">
        {/* Logo mark */}
        <div className="text-center mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white shadow-[rgba(0,0,0,0.08)_0px_0px_8px_0px] mx-auto mb-5">
            <Lock size={17} className="text-[#000000]" />
          </div>
          <h1
            className="text-[42px] font-[300] text-[#000000] leading-[1.15]"
            style={{ letterSpacing: "-1.5px" }}
          >
            Nice Page
          </h1>
          <p className="text-[#959595] text-sm font-[400] mt-2">請登入以繼續</p>
        </div>

        {/* Frosted card */}
        <div
          className="rounded-[30px] p-8 space-y-4"
          style={{
            background: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",
            boxShadow: "rgba(0, 0, 0, 0.08) 0px 0px 8px 0px",
          }}
        >
          {/* Google 登入 */}
          <form action={googleSignIn}>
            <input type="hidden" name="callbackUrl" value={callbackUrl} />
            <button
              type="submit"
              disabled={登入中}
              className="w-full flex items-center justify-center gap-3 px-5 py-3 rounded-[30px] bg-[#d9d9d9] text-[rgba(0,0,0,0.85)] text-sm font-[500] hover:bg-[#000000] hover:text-white transition-colors disabled:opacity-40"
            >
              <svg className="w-4 h-4 shrink-0" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>
              使用 Google 帳號登入
            </button>
          </form>

          <p className="text-center text-[11px] text-[#959595] pt-1">
            僅限受邀的使用者登入
          </p>
        </div>

        {/* Spectrum strip below card */}
        <div
          className="mt-6 h-0.5 w-2/3 mx-auto rounded-full opacity-50"
          style={{
            background:
              "linear-gradient(90deg, #c679c4 0%, #fa3d1d 25%, #ffb005 50%, #e1e1fe 75%, #0358f7 100%)",
          }}
        />
        <p className="text-center text-[11px] text-[#aeaeae] mt-4">Nice Page v0.1</p>
      </div>
    </div>
  );
}

export default function 登入頁() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-[#f8f8f8]" />}>
      <登入表單 />
    </Suspense>
  );
}
